import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose } from '@angular/material/dialog';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';

export interface SelectPlayerDialogData {
  players: number[];
}

@Component({
    selector: 'app-dialog-select-player',
    templateUrl: './dialog-select-player.component.html',
    styleUrls: ['./dialog-select-player.component.scss'],
    imports: [MatButtonToggleGroup, MatButtonToggle, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, TranslocoModule]
})
export class DialogSelectPlayerComponent {
  private dialogRef = inject(MatDialogRef<DialogSelectPlayerComponent>);
  data = inject<SelectPlayerDialogData>(MAT_DIALOG_DATA);

  select(player: number): void {
    this.dialogRef.close(player);
  }
}
